import { Directive, ViewContainerRef, Input } from '@angular/core';
import { VisitorService } from 'src/app/services';
import { ValidatorBase } from '../core/model';
import { Validator } from '../core/model/validator';

@Directive({
    selector: '[class-selection-validator]',
    host: { '(click)': 'changed($event)' },
    exportAs: 'validator'
})
export class ClassSelectionValidatorDirective extends ValidatorBase implements Validator
{
    @Input('class-selection-validator')
    public getValue: () => string;

    private readonly visitorService: VisitorService;

    public constructor(viewRef: ViewContainerRef, visitorService: VisitorService)
    {
        super(viewRef);
        this.visitorService = visitorService;
    }

    protected isValid(): boolean
    {
        return this.visitorService.getPreferences().paymentInterval != null;
    }

    public changed(event: any): void
    {
        this.validate();
    }

    public validate(): boolean
    {
        this.valid = this.isValid();
        return this.valid;
    }
}

